import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 1,
      "name": "sk.svg",
      "url": "https://api.gainer.fit/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 4,
    "name": "Poľský jazyk",
    "locale": "pl",
    "image": {
      "id": 4,
      "name": "pl.svg",
      "url": "https://api.gainer.fit/files/pl.svg?ai=0",
      "custom_title": "pl",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 5,
    "name": "Maďarský jazyk",
    "locale": "hu",
    "image": {
      "id": 5,
      "name": "hu.svg",
      "url": "https://api.gainer.fit/files/hu.svg?ai=0",
      "custom_title": "hu",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
